import shoppingGraphQLClient from './client';
import {
  GET_PRODUCT_LIST_PRODUCTS_BY_SLUG_QUERY,
  GET_PRODUCT_LIST_FACETS_BY_SLUG_QUERY,
  GET_RECOMMENDED_PRODUCTS_QUERY,
  GET_PRODUCT_LIST_HERO_BY_SLUG_QUERY,
} from './graphql/queries';

const RegistryShoppingGraphQL = {
  async getRecommendedProducts(model) {
    try {
      const res = await shoppingGraphQLClient.request(
        GET_RECOMMENDED_PRODUCTS_QUERY,
        model,
      );

      return res?.recommendations || [];
    } catch (error) {
      return [];
    }
  },

  async getProductListProductsBySlug(variables) {
    try {
      const res = await shoppingGraphQLClient.request(
        GET_PRODUCT_LIST_PRODUCTS_BY_SLUG_QUERY,
        variables,
      );

      return res?.productList || [];
    } catch (error) {
      return [];
    }
  },

  async getProductListHeroBySlug(slug) {
    try {
      const res = await shoppingGraphQLClient.request(
        GET_PRODUCT_LIST_HERO_BY_SLUG_QUERY,
        {slug},
      );

      return res?.productList || [];
    } catch (error) {
      return [];
    }
  },

  async getProductListFacetsBySlug(model) {
    try {
      const res = await shoppingGraphQLClient.request(
        GET_PRODUCT_LIST_FACETS_BY_SLUG_QUERY,
        model,
      );

      return res?.productList || [];
    } catch (error) {
      return [];
    }
  },
};

export default RegistryShoppingGraphQL;
